import React from 'react';
import O2Logo from '../Common/Logos/KindredLogo';
import styled from 'styled-components';
import { Description } from './Components';

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  padding: 1rem 0.5rem;
  padding-bottom: 50vh;
`;
const AndroidKeyboardInstallationGuide = () => {
  return (
    <Container>
      <O2Logo />
      <Description />
    </Container>
  );
};

export default AndroidKeyboardInstallationGuide;
